"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Strength = require("./Strength.style");

var _excluded = ["currentStrength", "label", "getStrengthString"];
var array = [1, 2, 3, 4, 5];

var checkStrength = function checkStrength(strength) {
  if (strength === 5) return {
    key: 'very-strong',
    value: 'Very Strong'
  };
  if (strength === 4) return {
    key: 'strong',
    value: 'Strong'
  };
  if (strength === 3) return {
    key: 'average',
    value: 'Average'
  };
  if (strength === 2) return {
    key: 'weak',
    value: 'Weak'
  };
  if (strength === 1) return {
    key: 'very-weak',
    value: 'Very Weak'
  };
  return false;
};

var Strength = function Strength(_ref) {
  var currentStrength = _ref.currentStrength,
      label = _ref.label,
      getStrengthString = _ref.getStrengthString,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var strength = typeof getStrengthString === 'function' ? getStrengthString(currentStrength) : checkStrength(currentStrength);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Strength.StyledTItle, {
    color: strength.key
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "label"
  }, label && label, /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('level-string')
  }, " ", strength.value))), /*#__PURE__*/_react["default"].createElement(_Strength.StyledStrengthWrap, (0, _extends2["default"])({}, props, {
    color: strength.key
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "eui-item-wrap"
  }, currentStrength ? array.map(function (step) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])("eui-item ".concat(step, " ").concat(currentStrength), {
        active: step <= currentStrength
      }),
      key: step
    });
  }) : null)));
};

Strength.defaultProps = {
  currentStrength: 0,
  radius: 25,
  label: 'Password Strength:'
};
Strength.propTypes = {
  width: _propTypes["default"].number,
  currentStrength: _propTypes["default"].number,
  radius: _propTypes["default"].number,
  label: _propTypes["default"].string,

  /**
  () => {
    if (strength === 5)
      return {
        key: 'very-strong',
        value: 'Very Strong',
      }
    if (strength === 4) return { key: 'strong', value: 'Strong' }
    if (strength === 3) return { key: 'average', value: 'Average' }
    if (strength === 2) return { key: 'weak', value: 'Weak' }
    if (strength === 1) return { key: 'very-weak', value: 'Very Weak' }
    return false
  }
  */
  getStrengthString: _propTypes["default"].func
};
var _default = Strength;
exports["default"] = _default;